<template>
  <component
    :is="isMobile ? 'NavigationMobile' : 'NavigationDesktop'"
    @close="onClose" :active="active"
  />
</template>

<script>
import NavigationDesktop from '@/views/Navigation/NavigationDesktop'
import NavigationMobile from '@/views/Navigation/NavigationMobile'

export default {
  props: ['active', 'currentPlan', 'planName'],
  components: {
    NavigationDesktop,
    NavigationMobile
  },
  computed: {
    isMobile () {
      return this.$vuetify.breakpoint.smAndDown
    }
  },
  methods: {
    onClose () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>

</style>
